import API from './axios';

export const addOrders = (payload) => API.post('order', payload);
export const getOrdersByCourtRef = (courtRef) => API.get(`order/${courtRef}`);
export const deleteOrderById = (orderId) => API.delete(`order/${orderId}`);
